module.exports = __webpack_public_path__ + "static/img/znyy.f6a9263.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/znyy.png
// module id = I270
// module chunks = 0